<template>
<div id="footer-container">
  <div id="logo-bar">
    <a  target="_blank" :href="'https://clarin-pl.eu/' + this.$i18n.locale">
      <img src="../assets/images/logo_cl.png" class="d-inline-block align-top"/>
    </a>
    <a v-if="this.$i18n.locale === 'pl'" target="_blank" href="https://pwr.edu.pl/">
      <img  src="../assets/images/pwr_PL.png" class="d-inline-block align-top" style="padding: 18px"/>
    </a>
    <a v-if="this.$i18n.locale === 'en'" target="_blank" href="https://pwr.edu.pl/en">
      <img  src="../assets/images/pwr_EN.png" class="d-inline-block align-top" style="padding: 18px"/>
    </a>
    <!--<router-link target="_blank" :to="{ name: 'Yyy'}"></router-link>-->
  </div>
  <!--<img src="../assets/images/logo_clarin.png" class="d-inline-block align-top"/>-->

</div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
#footer-container {
  height: 66px;
  /*background-color: var(--light_blue);*/
  background-color: var(--golden_light);
  text-align: center;
}
#logo-bar{
  height: 66px;
  /*background-color: var(--violet_red);*/
}
#logo-bar img {
  height:100%;
  padding: 5px;
  text-shadow: 2px 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue